export const ProductsEndpoints = {
    list: () => '/products',
    export: () => '/products/export',
    detail: (id: string) => `/products/${id}`,
    create: () => '/products',
    update: (id: string) => `/products/${id}`,
    delete: (id: string) => `/products/${id}`,
    archive: (id: string) => `/products/${id}/archive`,
    unarchive: (id: string) => `/products/${id}/unarchive`,
    variantBarcodes: (id: string, variantId: string) =>
        `/products/${id}/variants/${variantId}/barcodes`,
};
